import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ChallengesService {
  fetchIndex({ includes = [], page, perPage } = {}) {
    return securedAxiosInstance.get("/challenges", { params: toSnakeCase({ includes, page, perPage }) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/challenges/${id}`, { params: { includes } });
  }

  update(id, data) {
    return securedAxiosInstance.put(`/challenges/${id}`, { challenge: toSnakeCase(data) });
  }

  delete(id) {
    return securedAxiosInstance.delete(`/challenges/${id}`);
  }

  create(data) {
    return securedAxiosInstance.post("/challenges", { challenge: toSnakeCase(data) });
  }

  getPerformance(storeId, challengeId) {
    return securedAxiosInstance.get("/challenges/performance", {
      params: { store_id: storeId, challenge_id: challengeId },
    });
  }

  downloadReporting(challengeId, storeIds) {
    return securedAxiosInstance.get("/challenges/reporting", {
      params: { challenge_id: challengeId, store_ids: storeIds },
    });
  }

  addOrganizations(challengeId, organizations) {
    return securedAxiosInstance.post(`/challenges/${challengeId}/organizations`, { organizations });
  }
}

export default new ChallengesService();
